import {REPORT_ERROR,REPORT_SUCCESS,REPORT_REQUEST,REPORT_CHANGEFIELD,REPORT_CHANGESETTINGS,REPORT_RESET} from '../actions/reportActions'
import clone from 'clone'

const initialState = {
    fetching:false,
    data:{
        id:0,
        name:"",
        isActive:true,
        consolidatedReportSettings: {
            startHour: 0,
            startMinute: 0,
            companyId: 0,
            bindings: [],
            redmineFolders:[]
        }
    }

}

export default function report(state=clone(initialState), action){
    switch (action.type){
        case REPORT_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case REPORT_SUCCESS:
            return{
                ...state,
                fetching:false,
                data:action.payload
            }
        case REPORT_ERROR:
            return{
                ...state,
                data:clone(initialState.data),
                fetching:false
            }
        case REPORT_CHANGEFIELD:
            return{
                ...state,
                data:{
                    ...state.data,
                    [action.payload.field]:action.payload.value
                }
            }
        case REPORT_CHANGESETTINGS:
            return{
                ...state,
                data:{
                    ...state.data,
                    consolidatedReportSettings:{
                        ...state.data.consolidatedReportSettings,
                        [action.payload.field]:action.payload.value
                    }
                }
            }
        case REPORT_RESET:
            return {...clone(initialState)}

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/report.js